import PageLayout from "@/components/PageLayout";
import Booking from "@/components/Booking";
import SEO from "@/components/SEO";

export default function PrenotaPage() {
  return (
    <PageLayout>
      <SEO
        title="Prenota una seduta online"
        description="Prenota online il tuo primo colloquio con la Dott.ssa Chiara Maiolo. Indica la tua preferenza tra mattina e pomeriggio. Sedute in studio a Chivasso o online."
        keywords="prenota psicologa Chivasso, primo colloquio psicologico, seduta online"
        path="/prenota"
      />
      <div data-testid="prenota-page" className="pt-24">
        <Booking />
      </div>
    </PageLayout>
  );
}
